import { RefuseOnCallSpecialist } from '~/domain/usecases/onCallSpecialist/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteRefuseOnCallSpecialist implements RefuseOnCallSpecialist {
  private readonly url: string;

  private readonly httpClient: HttpClient<RefuseOnCallSpecialist.Model>;

  constructor(
    url: string,
    httClient: HttpClient<RefuseOnCallSpecialist.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  refuse = async (
    params: RefuseOnCallSpecialist.Params,
  ): Promise<RefuseOnCallSpecialist.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', params.onCallId.toString())
        .replace('{specialistId}', params.specialistId.toString())
        .replace('{requestId}', params.requestId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
